import settings from '../settings.js'

import surveyTplModal from '../templates/survey-modal-tpl.html'

const $inject = ['$scope', 'common', '$state', '$timeout', '$ionicModal', 'ArticleService', '$rootScope', '$stateParams']

function NewsCtrl(scope, common, state, timeout, ionicModal, ArticleService, rootScope, stateParams) {
    if (!common.shared.activeNews && !stateParams.articleId)
        state.go(settings.stateFront);

    scope.settings = settings;

    scope.setLanguage = UserService.setLanguage;
    scope.getLangCode = UserService.getLangCode;

    scope.news = {};

    scope.getNewsArticle = (articleId) => {
        ArticleService.getNewsArticle(articleId, (data) => {
            if (data.items[0] && data.items[0].content)
                scope.news = data.items[0];
        });
    };

    //Get news again if language changed.
    scope.$on('language.changed', (event, newLangCode) => {
        ionicConfig.backButton.text(_locale('back').ucfirst());
        scope.getNewsArticle(scope.news.id);
    });

    if (!!common.shared.activeNews) {
        timeout(() => {
            scope.news = common.shared.activeNews;
        });
	}

    if (stateParams.articleId)
        scope.getNewsArticle(stateParams.articleId);

    scope.openSurvey = (hash) => common.openSurvey(hash, scope);

    scope.survey = {};

    scope.saveSurvey = common.getBasicSurveySave(scope, 'surveyModal');

    ionicModal.fromTemplateUrl(surveyTplModal, {
        scope: scope
    }).then((modal) => {
        scope.surveyModal = modal;
    });
    
    scope.$on('youtube.player.ready', ($event, player) => {
        rootScope.YTPlayer = player;
    });

    document.addEventListener('pause', () => {
        if (rootScope.YTPlayer)
            rootScope.YTPlayer.stopVideo();
    }, false);

    scope.$on('$ionicView.beforeLeave', () => {
        if (rootScope.YTPlayer)
            rootScope.YTPlayer.stopVideo();
    });

    scope.$on('wisenetwork.ionic.refreshNews', (evt, news) => {
        timeout(() => {
            scope.news = news;
        });
    });
}

NewsCtrl.$inject = $inject

export default NewsCtrl